import { render, staticRenderFns } from "./tableLocation.vue?vue&type=template&id=64274610&scoped=true&"
import script from "./tableLocation.vue?vue&type=script&lang=js&"
export * from "./tableLocation.vue?vue&type=script&lang=js&"
import style0 from "./tableLocation.vue?vue&type=style&index=0&id=64274610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64274610",
  null
  
)

export default component.exports